import React from 'react';
import Title from '../Title';
import type { ContractedService } from '~/domain/Assegurou/contractedServices';
import ServiceCard from './components/ServiceCard';
import Container from '../Container';

interface Props {
  data?: ContractedService[];
}

const MyServices: React.FC<Props> = ({ data }) => {
  if (!data || data.length === 0) return null;

  return (
    <Container>
      <Title title="Meus serviços contratados" />

      {data.map((service, index) => (
        <ServiceCard key={index} data={service} />
      ))}
    </Container>
  );
};

export default MyServices;
